import React from "react";

//helpers
import { getUserActivityIcon } from "../../../../helpers/IconLibrary";

//components
import Icon from "../../../global/icons/Icon";



const UserActivityImage = ({activity}:{activity: string}) => {   

  return (
    <div className={`user-activity-image-wrapper ${activity}`} aria-hidden="true">
        <Icon className={getUserActivityIcon(activity)} iconName={getUserActivityIcon(activity)} sizeInPx="10"/>
    </div>
  );
}

export default UserActivityImage